// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3ev1P","footer":"ChangeClinic_footer__1PoGt"};